// employeeDisplay.js — small presentation helpers for the Staff / Employees UI.
// Ported from the Nami "Staff Management" design handoff (staff-data.jsx).

// Deterministic pastel tint per name, harmonized with the lavender palette.
export function sfTint(seed = '') {
	let h = 0
	for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) % 360
	const hue = [262, 268, 255, 210, 158, 28, 340][h % 7]
	return { bg: `oklch(0.94 0.05 ${hue})`, fg: `oklch(0.45 0.12 ${hue})` }
}

// Up-to-two-letter initials from a full name.
export function sfInitials(name = '') {
	return name
		.split(' ')
		.map((w) => w[0])
		.filter(Boolean)
		.slice(0, 2)
		.join('')
		.toUpperCase()
}

// Status pill colors. The current employee model only has an `active` boolean,
// so we map true → Active, false → Inactive (the design's "On leave" state is a
// feature we don't implement here).
export function statusViz(active) {
	if (active !== false) {
		return { label: 'Active', bg: '#E9F6EE', fg: '#25714A', dot: '#2F8A5B' }
	}
	return { label: 'Inactive', bg: '#F1EFF6', fg: '#8B85A4', dot: '#B4ADC6' }
}
